var C = (p, v, l) => new Promise((r, m) => {
  var e = (o) => {
    try {
      n(l.next(o));
    } catch (a) {
      m(a);
    }
  }, f = (o) => {
    try {
      n(l.throw(o));
    } catch (a) {
      m(a);
    }
  }, n = (o) => o.done ? r(o.value) : Promise.resolve(o.value).then(e, f);
  n((l = l.apply(p, v)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { useDraggable as D } from "./composables/useDraggable.js";
import E from "./images/collapse.png.js";
import N from "./images/expand.png.js";
import { defineComponent as j, onMounted as I, nextTick as M, watch as K, onUnmounted as L, openBlock as w, createElementBlock as d, createVNode as R, withCtx as S, Fragment as W, renderList as X, createElementVNode as c, createCommentVNode as b } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as z, unref as u } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { withModifiers as T, Transition as Y } from "../../node_modules/.pnpm/@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
import { normalizeStyle as $, normalizeClass as V, toDisplayString as F } from "../../node_modules/.pnpm/@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
const H = {
  key: 0,
  class: "tw:bg-white tw:rounded-lg tw:shadow-xl tw:overflow-hidden tw:min-w-[180px] tw:border tw:border-gray-100 tw:max-h-[400px] tw:overflow-y-auto"
}, O = ["onClick", "onMouseenter"], U = {
  key: 0,
  class: "tw:relative tw:w-4 tw:h-4 tw:mr-2.5 tw:flex tw:items-center tw:justify-center tw:flex-shrink-0"
}, q = ["src", "alt"], A = ["src"], G = ["src"], nt = /* @__PURE__ */ j({
  __name: "floatWindowContent",
  props: {
    list: { default: () => [] },
    activeKey: { default: "" },
    initialX: { default: 20 },
    initialY: { default: 20 },
    draggable: { type: Boolean, default: !0 }
  },
  emits: ["click"],
  setup(p, { expose: v, emit: l }) {
    const r = p, m = l, e = z(!0), f = z(""), n = (s) => r.activeKey === s || f.value === s, {
      elementRef: o,
      position: a,
      hasDragged: y,
      onDragStart: h,
      clampToViewport: g
    } = D({
      draggable: r.draggable,
      initialX: r.initialX,
      initialY: r.initialY,
      dragThreshold: 5
    }), x = () => {
      e.value = !e.value;
    }, k = () => {
      y.value || x();
    }, B = (s) => {
      y.value || m("click", s);
    };
    return I(() => {
      M(() => g()), window.addEventListener("resize", g);
    }), K(e, () => C(this, null, function* () {
      yield M(), g();
    })), L(() => {
      window.removeEventListener("resize", g);
    }), v({
      toggleMenu: x,
      closeMenu: () => {
        e.value = !1;
      },
      openMenu: () => {
        e.value = !0;
      }
    }), (s, i) => (w(), d("div", {
      ref_key: "floatWindowRef",
      ref: o,
      class: "tw:fixed tw:z-1000 tw:select-none",
      style: $({
        left: u(a).x + "px",
        bottom: u(a).y + "px"
      }),
      onMousedown: i[1] || (i[1] = //@ts-ignore
      (...t) => u(h) && u(h)(...t))
    }, [
      R(Y, { name: "menu-fade" }, {
        default: S(() => [
          e.value ? (w(), d("div", H, [
            (w(!0), d(W, null, X(s.list, (t) => (w(), d("div", {
              key: t.key,
              class: V([
                "tw:flex tw:items-center tw:px-3.5 tw:py-2.5 tw:cursor-move tw:transition-all tw:border-b tw:border-gray-100",
                n(t.key) ? "tw:bg-gradient-to-r tw:from-blue-50 tw:to-white tw:border-l-4 tw:border-l-blue-500 tw:font-medium" : "tw:bg-white"
              ]),
              onClick: T((_) => B(t), ["stop"]),
              onMouseenter: (_) => f.value = t.key,
              onMouseleave: i[0] || (i[0] = (_) => f.value = "")
            }, [
              t.icon ? (w(), d("div", U, [
                c("img", {
                  draggable: !1,
                  src: t.icon,
                  alt: t.label,
                  class: "tw:w-full tw:h-full tw:object-contain"
                }, null, 8, q)
              ])) : b("", !0),
              c("span", {
                class: V([
                  "tw:text-sm tw:whitespace-nowrap",
                  n(t.key) ? "tw:text-blue-600" : "tw:text-gray-800 tw:font-normal"
                ])
              }, F(t.label), 3)
            ], 42, O))), 128)),
            c("div", {
              class: "tw:flex tw:items-center tw:py-2.5 tw:bg-gray-50 tw:cursor-move tw:transition-all tw:rounded-b-lg",
              onClick: T(k, ["stop"])
            }, [
              c("img", {
                draggable: !1,
                src: u(E),
                alt: "收起",
                class: "tw:w-6 tw:h-6 tw:mr-1"
              }, null, 8, A),
              i[2] || (i[2] = c("span", { class: "tw:text-sm tw:text-gray-600" }, "收起", -1))
            ])
          ])) : b("", !0)
        ]),
        _: 1
      }),
      e.value ? b("", !0) : (w(), d("div", {
        key: 0,
        class: "tw:flex tw:items-center tw:justify-center tw:w-12 tw:h-12 tw:bg-white tw:rounded-full tw:cursor-move tw:shadow-lg tw:transition-all tw:border tw:border-gray-200",
        onClick: k
      }, [
        c("img", {
          draggable: !1,
          src: u(N),
          alt: "展开",
          class: "tw:w-7 tw:h-7"
        }, null, 8, G)
      ]))
    ], 36));
  }
});
export {
  nt as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/float-window/floatWindowContent.vue2.js
// module id = 1248
// module chunks = 41